export default "__VITE_ASSET__l0kT81uZ__"